import { inject, observer } from "mobx-react";
import { computed } from "mobx";

import "./style.scss";

const Loader = inject("mainStore")(observer(({ mainStore }) => {
    const loader = computed(() => mainStore.getMainStore("loader")).get();
    const auth = computed(() => mainStore.getMainStore("auth")).get();
    const token = localStorage.getItem("_cms_token_v1");

    return loader ? (
        <div className={`loader ${token && !auth ? "loader_bg" : ""}`}>
            <div className="lds-ripple">
                <div></div>
                <div></div>
            </div>
        </div>
    ) : null;
}),
);

export default Loader;
